import React, { useState } from 'react';
import { Box } from '@mui/material';

import { createScrollbarStyling } from '@paragon/themes';

import { useScrollTo } from '../../../scrolling';
import { NavigationPanel } from '../../interface/panels/navigation-panel/NavigationPanel';
import { PropertiesPanel } from '../../interface/panels/PropertiesPanel';
import { ResizeDivider } from '../../ResizeDivider';

const DEFAULT_GRID_HEIGHT = 300;

interface Props {
  visible: boolean;
}

export default function RightToolbar({ visible }: Props) {
  const scrollTarget = useScrollTo('selectedItemProperties');

  const [gridHeight, setGridHeight] = useState(DEFAULT_GRID_HEIGHT);

  return (
    <Box sx={{ display: visible ? 'flex' : 'none', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Box sx={{ padding: 2 }}>
        <NavigationPanel gridHeight={gridHeight} />
      </Box>

      <ResizeDivider type="vertical" value={gridHeight} onChange={setGridHeight} />

      <Box
        ref={scrollTarget}
        sx={[
          { padding: 2, paddingTop: 0, overflowX: 'hidden', overflowY: 'auto', minHeight: 0 },
          createScrollbarStyling,
        ]}
      >
        <PropertiesPanel />
      </Box>
    </Box>
  );
}
